import Network from '@/services/network'

export default function handleDropdowns() {
    const network = new Network;

    const fetchProductDropdownList = (query) => {
        return network.api('get', '/dropdowns/products'+query);
    }

    const fetchContactProfileDropdownList = (query) => {
        return network.api('get', '/dropdowns/contact-profile-names'+query);
    }

    const fetchActivitySetupEndpoint = (query) => {
        return network.api('get', '/dropdowns/activity-setup-endpoint'+query);
    }

    const fetchPayHeadDropdown = (query) => {
        return network.api('get', '/dropdowns/pay-head-dropdown'+query);
    }

    const fetchLetterTemplateDropdown = (query) => {
        return network.api('get', '/dropdowns/letter-template'+query);
    }

   const fetchPerformanceApprisalSetupDropdown = (query) => {
        return network.api('get', '/dropdowns/performance-apprisal-setup'+query);
    }

    const fetchDropdownList = (query) => {
        return network.api('get', '/dropdowns/list'+query);
    }

    return {
        fetchProductDropdownList,
        fetchContactProfileDropdownList,
        fetchActivitySetupEndpoint,
        fetchPayHeadDropdown,
        fetchDropdownList,
        fetchLetterTemplateDropdown,
        fetchPerformanceApprisalSetupDropdown
    }
}
